module.exports = __webpack_public_path__ + "static/media/target-icon.7b4e7204.svg";